export default __webpack_public_path__ + "static/media/young_and_old.4234f3f1.svg";